import { useTranslation } from "react-i18next";
import { AREA_BY_ID } from "../content/map";

export function WorldIntroPanel({ compact = false }: { compact?: boolean }) {
  const { t, i18n } = useTranslation(["common", "learner"]);
  const isJa = i18n.language === "ja";
  const airport = AREA_BY_ID.airport;

  return (
    <div className={`bg-white/88 backdrop-blur rounded-2xl shadow-lg border border-white/70 overflow-hidden ${compact ? "" : "mb-4"}`}>
      <div className="px-5 py-4 bg-gradient-to-br from-sky-100 via-white to-sakura/20">
        <div className="text-[11px] font-bold text-primary/70 tracking-wide uppercase">
          {isJa ? "Nihongo Island への入口" : "Gateway to Nihongo Island"}
        </div>
        <h1 className="mt-1 text-2xl font-bold text-primary leading-tight">
          {t("learner:welcome_title")}
        </h1>
        <p className="mt-2 text-sm text-body leading-relaxed">
          {isJa ? airport.storyCopyJa : airport.storyCopyEn}
        </p>
      </div>
      <div className="px-5 py-3 flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-black shrink-0">
          KIX
        </div>
        <div className="min-w-0">
          <div className="text-sm font-bold text-primary">
            {isJa ? airport.residentNameJa : airport.residentNameEn}
          </div>
          <p className="text-sm text-muted leading-relaxed">
            {isJa ? airport.guideCopyJa : airport.guideCopyEn}
          </p>
        </div>
      </div>
    </div>
  );
}
